import {useGetAccount} from "~/api/requests";
import {useAccountId} from "~/hooks";

export const useAccount = ({includeOffers}: {includeOffers?: boolean} = {}) => {
  const accountId = useAccountId();

  const {data: account, isLoading: isLoadingAccount} = useGetAccount(
    {accountId, includeOffers},
    {enabled: !!accountId}
  );

  return {accountId, account, isLoadingAccount};
};
